<div
  class="list"
  infiniteScroll
  [infiniteScrollDistance]="2"
  [infiniteScrollThrottle]="50"
  (scrolled)="onScrollDown()"
  [infiniteScrollContainer]="infiniteScrollContainer"
  [fromRoot]="true"
  [scrollWindow]="true"
>
  <gd-card
    *ngFor="let card of cards; trackBy: itemTrackBy"
    class="project-card"
    [overlayBtnText]="overlayBtnText"
    [card]="card"
    [dropdownMenuItems]="dropdownMenuItems"
    (dropdownMenuItemClick)="dropdownMenuItemClick.emit($event)"
    (cardClick)="cardClick.emit($event)"
  >
  </gd-card>
</div>
